/* eslint-disable @typescript-eslint/no-explicit-any */
const offsetCenter = (
    latlng: any,
    offsetx: any,
    offsety: any,
    maps: any,
    map: any
) => {
    const scale = Math.pow(2, map.getZoom());
    const worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
    const pixelOffset = new maps.Point(
        offsetx / scale || 0,
        offsety / scale || 0
    );
    const worldCoordinateNewCenter = new maps.Point(
        worldCoordinateCenter.x - pixelOffset.x,
        worldCoordinateCenter.y + pixelOffset.y
    );
    const newCenter = map
        .getProjection()
        .fromPointToLatLng(worldCoordinateNewCenter);
    map.setCenter(newCenter);
};

export const setCenter = (maps: any, map: any, config: any) => {
    if (window.innerWidth > 567) {
        maps.event.addListener(map, "idle", () => {
            const pos = new maps.LatLng(config?.lat, config?.lng);
            offsetCenter(pos, 150, 0, maps, map);
        });
    } else {
        maps.event.clearListeners(map, "idle");
        map.setCenter({ lat: config?.lat, lng: config?.lng });
    }
};

export const locationDetailMap = ({
    maps,
    config,
    mapStyles,
    mapTarget,
    routeLinkSelector,
}) => {
    const map = new maps.Map(mapTarget, {
        zoom: 1,
        center: { lat: config?.lat, lng: config?.lng },
        mapTypeControl: false,
        styles: mapStyles,
    });

    const image = {
        url: config.icon,
        scaledSize: new maps.Size(53, 70),
        origin: new maps.Point(0, 0),
        anchor: new maps.Point(10, 60),
    };

    new maps.Marker({
        position: { lat: config?.lat, lng: config?.lng },
        map: map,
        icon: image,
        zIndex: 1,
    });

    map.setZoom(15);

    const mapsRoute =
        "https://maps.google.com?saddr=Current+Location&daddr=" +
        config?.lat +
        "," +
        config?.lng;
    const routeLink = document.querySelector(routeLinkSelector);
    if (routeLink) {
        routeLink.setAttribute("href", mapsRoute);
    }

    return map;
};

// locationDetailMap but instead of google-maps we use baidu-maps
export const baiduLocationDetailMap = async ({
    maps,
    config,
    // mapStyles,
    mapTarget,
    routeLinkSelector,
}) => {
    const map = new maps.Map(mapTarget, {
        zoom: 4,
        center: new maps.Point(btoa(config?.lng), btoa(config?.lat)),
        mapTypeControl: false,
        // styles: mapStyles,
    });

    const image = new maps.Icon(config.icon, new maps.Size(53, 70), {
        anchor: new maps.Size(10, 60),
    });

    const marker = new maps.Marker(
        new maps.Point(btoa(config?.lng), btoa(config?.lat)),
        {
            icon: image,
        }
    );
    map.addOverlay(marker);

    map.setZoom(5);

    const mapsRoute =
        "https://maps.baidu.com?saddr=Current+Location&daddr=" +
        config?.lat +
        "," +
        config?.lng;
    const routeLink = document.querySelector(routeLinkSelector);
    if (routeLink) {
        routeLink.setAttribute("href", mapsRoute);
    }

    return map;
};

export const baiduSetCenter = async (
    maps: any,
    map: any,
    config: any,
    zoom: number
) => {
    map.centerAndZoom(
        new maps.Point(btoa(config?.lng), btoa(config?.lat)),
        zoom
    );
};
